import { render } from "./list.vue?vue&type=template&id=12336c3e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=12336c3e&scoped=true&lang=css"

import exportComponent from "/var/www/gapp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12336c3e"]])

export default __exports__